import React from "react";
import * as FaIcons from "react-icons/fa";

import languageList from "../../../data/languageList";

const R9HomeLanguage = ({
  formData,
  onFormDataChange,
  validationCheck,
  setLanguageToEnglish,
}) => {
  const {
    firstName,
    firstLanguage,
    homeLanguage,
    languageSpokenByParentsToStudent,
    languageSpokenByAdultsAtHome,
  } = formData;
  return (
    <>
      {/* Home Language Survey */}
      <div className="sub-form">
        <h3>Home Language Survey</h3>
        <div className="sum-item">
          <div className="btn-container">
            <div
              onClick={setLanguageToEnglish}
              className="btn btn-llac-dark-green"
            >
              Set all to English
            </div>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the Student" : firstName}'s First
              Language?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>

          <select
            name="firstLanguage"
            value={firstLanguage}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(firstLanguage !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {languageList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What Language is Spoken at{" "}
              {firstName === "" ? "the Student" : firstName}'s Home?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="homeLanguage"
            value={homeLanguage}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(homeLanguage !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {languageList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What Language is Spoken by Parent/Guardian to{" "}
              {firstName === "" ? "the Student" : firstName}?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="languageSpokenByParentsToStudent"
            value={languageSpokenByParentsToStudent}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(languageSpokenByParentsToStudent !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {languageList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What Language is Spoken by Adults at{" "}
              {firstName === "" ? "the Student" : firstName}'s Home?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="languageSpokenByAdultsAtHome"
            value={languageSpokenByAdultsAtHome}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(languageSpokenByAdultsAtHome !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {languageList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>
      </div>
    </>
  );
};

export default R9HomeLanguage;
